import gql from "graphql-tag";

export const SEARCH_CHECK_REQUESTS = gql`
  query (
    $pageNumber: Int!
    $rowsPerPage: Int!
    $searchCriteria: checkSearchCriteria
  ) {
    searchCheckRequests(
      pageNumber: $pageNumber
      rowsPerPage: $rowsPerPage
      searchCriteria: $searchCriteria
    ) {
      statusCode
      message
      data
    }
  }
`;

export const UPDATE_ALLOCATION = gql`
  mutation (
    $requestId: String!
    $allocatedEmail: String!
    $allocatedUsername: String!
  ) {
    allocateRequest(
      requestId: $requestId
      allocatedEmail: $allocatedEmail
      allocatedUsername: $allocatedUsername
    ) {
      statusCode
      message
      data
    }
  }
`;

export const CREATE_CHECK_REQUESTS = gql`
  mutation (
    $checkType: String
    $entityId: String
    $mdmId: String
    $dnbId: String
    $confidential: Boolean
    $countryId: String
  ) {
    createCheckRequest(
      checkType: $checkType
      entityId: $entityId
      mdmId: $mdmId
      dnbId: $dnbId
      confidential: $confidential
      countryId: $countryId
    ) {
      statusCode
      message
      data
    }
  }
`;

export const CANCEL_REQUEST = gql`
  mutation ($requestId: String!, $cancelAssociations: Boolean) {
    cancelRequest(
      requestId: $requestId
      cancelAssociations: $cancelAssociations
    ) {
      statusCode
      message
      data
    }
  }
`;

export const RESTART_REQUEST = gql`
  mutation ($requestId: String!) {
    restartRequest(requestId: $requestId) {
      statusCode
      message
      data
    }
  }
`;

export const RESTART_COMPLETED_CHECK = gql`
  mutation ($requestId: String!) {
    restartCompletedCheck(requestId: $requestId) {
      statusCode
      message
    }
  }
`;

export const REFER_TO_DEAL_TEAM = gql`
  mutation ($entityId: String!) {
    referToDealTeam(entityId: $entityId) {
      statusCode
      message
    }
  }
`;

export const REFER_BACK_FROM_DEAL_TEAM = gql`
  mutation ($entityId: String!) {
    referBackFromDealTeam(entityId: $entityId) {
      statusCode
      message
    }
  }
`;
